import styled from '@emotion/styled';

export const Nav = styled.nav`
  display: flex;
  flex-direction: column;
  margin-left: auto;

  .auth-button {
    font-weight: bold;

    &:not(:last-child) {
      margin-bottom: 10px;
    }
  }
`;

export const NavButtonSection = styled.section`
  display: flex;
  justify-content: flex-end;

  span {
    font-size: 14px;
    line-height: 24px;
  }

  @media (max-width: ${props => props.theme.breakpoints.l}) {
    display: none;
  }
`;

export const NavButton = styled.span`
  padding-left: 9px;
  color: ${props => props.theme.colors.black};
  a {
    color: ${props => props.theme.colors.black};
    cursor: pointer;
    &.blue-link {
      color: ${props => props.theme.colors.blue};
    }
  }
  &:not(:last-child) {
    border-right: ${props => props.theme.borders.card};
    padding-right: 9px;
  }
  &.login-button {
    border-right: none;
  }
`;

export const NavIconSection = styled.section`
  display: flex;
  margin-top: 10px;
  align-items: center;
  margin-left: auto;

  @media (max-width: ${props => props.theme.breakpoints.l}) {
    margin-top: 0;
  }
`;

export const NavIcon = styled.span`
  display: flex;
  padding: 0px 12px;
  border-right: ${props => props.theme.borders.card};
  cursor: pointer;
  position: relative;

  @media (max-width: ${props => props.theme.breakpoints.l}) {
    border-right: none;
    padding: 0;
    margin: 0px 10px;

    display: ${props => (props.mobileHidden ? 'none' : 'flex')};
  }

  @media all and (min-width: ${props => props.theme.breakpoints.l}) {
    display: ${props => (props.desktopHidden ? 'none' : 'flex')};
  }

  &:first-of-type {
    margin-left: 0px;
    padding-left: 0px;
  }

  &:last-of-type {
    margin-right: 0px;
    padding-right: 0px;
    border-right: none;
  }

  svg {
    color: ${props => props.theme.colors.black};
    width: 20px;
    height: auto;
    display: flex;
    align-items: center;
  }

  button.snipcart-checkout {
    background: none;
    border: none;
    outline: none;
    padding: 0px;
    cursor: pointer;
    display: flex;
    align-items: center;
    .cart-count {
      margin-left: 3px;
      vertical-align: top;
      background: #262626;
      -moz-border-radius: 0.75em;
      -webkit-border-radius: 0.75em;
      color: #fff;
      display: inline-block;
      font-weight: 400;
      line-height: 1.5em;
      text-align: center;
      width: 1.5em;
      font-size: 12px;
    }
  }
`;
